/**
 * File: homePage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v3.3.2
 * Created: 2025-12-04
 * Last Updated: 2026-02-25
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Home Page
export const homePage = {
    meta: {
        id: "home-page",
    },
    hero: {
        headline:
            "Scale Your Engineering Capacity with Smart Tools & Expert Support",
        subheadline:
            "All-in-one MEP solutions — from drafting and surveying to automated QA/QC and HVAC design tools — built to help your team deliver faster and with confidence.",
        primaryButton: {
            text: "Get Started",
            type: "primary",
        },
        secondaryButton: {
            text: "Get Estimate",
            type: "secondary",
        },
    },
};
